import { updateProject, validateProject } from '../api/client';
import { useEditorStore } from '../store/editorStore';
import { useSimulationStore } from '../store/simulationStore';
import type { ValidationIssue } from '../types/validation';

// ------------------------------------------------------------
// Persist project fixes and refresh validation UI
// ------------------------------------------------------------

export async function persistDocumentAndRefreshValidation(): Promise<{
  ok: boolean;
  remainingIssues: ValidationIssue[];
  error?: string;
}> {
  const editor = useEditorStore.getState();
  const { projectId, document, record, loadProject, markSaved } = editor;
  if (!projectId || !document || !record) {
    return { ok: false, remainingIssues: [], error: 'Project is not loaded.' };
  }

  try {
    const scenarios = useSimulationStore.getState().scenarios;
    const updated = await updateProject(projectId, {
      name: document.name,
      description: document.description,
      document: { ...document, scenarios },
    });
    loadProject(updated);
    markSaved();

    const validation = await validateProject(projectId);
    const remainingIssues = validation.issues.filter(
      (issue) => issue.severity === 'error',
    );

    if (remainingIssues.length === 0) {
      useSimulationStore.getState().resetRun();
    } else {
      useSimulationStore
        .getState()
        .setRunValidationIssues(
          remainingIssues,
          'Simulation blocked by project validation errors',
        );
    }

    return { ok: remainingIssues.length === 0, remainingIssues };
  } catch (err) {
    return {
      ok: false,
      remainingIssues: useSimulationStore.getState().run.issues,
      error: err instanceof Error ? err.message : 'Failed to save project fixes',
    };
  }
}
